import jBox from 'jbox';

let choiceTooltipInstance = null;

function bindChoiceTooltipA11y($triggers) {
    $triggers
        .off('.gformChoiceTooltip')
        .on('focus.gformChoiceTooltip', function () {
            jQuery(this).trigger('mouseenter');
        })
        .on('blur.gformChoiceTooltip', function () {
            jQuery(this).trigger('mouseleave');
        })
        .on('keydown.gformChoiceTooltip', function (e) {
            if (e.key === 'Escape' || e.key === 'Esc') {
                jQuery(this).trigger('mouseleave');
            }
        });
}

function initGformChoiceTooltips() {
    const $triggers = jQuery('.gform-choice-tooltip');
    if (!$triggers.length) {
        return;
    }

    if (choiceTooltipInstance) {
        choiceTooltipInstance.destroy();
        choiceTooltipInstance = null;
    }

    choiceTooltipInstance = new jBox('Tooltip', {
        attach: '.gform-choice-tooltip',
        getContent: 'data-tooltip',
        closeOnMouseleave: true,
        closeOnEsc: true,
        adjustPosition: true,
        adjustTracker: true,
        adjustDistance: 16,
        reposition: true,
        repositionOnOpen: true,
        pointer: true,
        maxWidth: 230,
        addClass: 'gform-choice-tooltip-box',
        position: {
            x: 'center',
            y: 'top',
        },
        outside: 'y',
    });

    bindChoiceTooltipA11y($triggers);
}

jQuery(document).ready(function () {
    initGformChoiceTooltips();
});

jQuery(document).on('gform_post_render gform_page_loaded', function () {
    initGformChoiceTooltips();
});
